<template>
  <v-container fluid white class="py-3 white">
    <div class="justify-start mt-3">
      <credenciamento-modal-nova-demanda @atualizar="buscarDemandas" v-az-auth="'Credenciamento.Editar'"/>
    </div>
    <v-expansion-panel
        v-model="painelAberto"
        class="mt-3 demanda-expansion"
    >
      <template v-if="demandas && demandas.itens">
      <v-expansion-panel-content
          v-if="demandas && demandas.itens"
          v-for="(demanda) in demandas.itens"
          :key="demanda.id"
      >
        <template v-slot:header>
          <v-layout align-center>
            <v-icon class="mr-3 grey--text">list</v-icon>

            <div>
              <span class=""><b class="primary--text">Contratação {{ demanda.numero }}</b></span>
              <span class="ml-2 mr-2">|</span>
              <span>Órgão: {{ demanda.siglaUnidadeOrganizacional }}</span>
              <span class="ml-2 mr-2">|</span>
              <span>Fornecedor: {{ demanda.razaoSocial }}</span>
              <span class="ml-2 mr-2">|</span>
              <span class="ml-2 mr-2">{{ demanda.situacao }}</span>
              <credenciamento-modal-motivo-cancelamento v-if="demanda.situacao === 'Cancelada'" :motivo="demanda.justificativaCancelamento"/>
                 <span v-if="demandasComPreparacaoAberta[demanda.id] && !demanda.idExternoProcessoAquisicao">
                    <span class="ml-2 mr-2">|</span>
                    <span class="ml-2 mr-2">
                      <v-icon small color="grey darken-1" class="mdi-spin">mdi-loading</v-icon>
                      Enviado para o Preparação (Aguardando geração do link)
                  </span>
                </span>
              <span class="ml-2 mr-2" v-if="demanda && demanda.idExternoProcessoAquisicao">
                <span class="ml-2 mr-2">|</span>
                <a href="#" @click.prevent="abrirProcessoAquisicao(demanda)" class="processo-link">
                  {{ demanda.numeroProcesso || 'Acessar Processo' }}
                </a>
              </span>
            </div>

            <v-spacer></v-spacer>

            <v-card-actions v-if="isEditingDemanda(demanda.id) && hasAnyQuantityChanged(demanda)">
              <v-spacer></v-spacer>
              <v-btn
                  icon
                  small
                  @click="confirmarAlteracoes(demanda)"
                  class="mr-2 justify-center"
              >
                <v-icon medium class="mr-1 green--text confirmar">check</v-icon>
              </v-btn>
            </v-card-actions>

            <v-btn icon small class="ml-2" @click.stop="toggleEdicaoDemanda(demanda)" v-if="podeEditar(demanda.situacao)" v-az-auth="'Credenciamento.Editar'">
              <v-icon small v-if="!isEditingDemanda(demanda.id)">edit</v-icon>
              <v-icon small v-else color="primary">edit_off</v-icon>
            </v-btn>

            <v-tooltip top v-if="deveMostrarBotaoIrParaPreparacao(demanda)">
              <template #activator="{ on, attrs }">
                <v-btn icon small class="ml-2 btn-inexigibilidade" v-bind="attrs" v-on="on" @click.stop="abrirModalSelecionarDocumentos(demanda)">
                  <v-icon small color="grey darken-1">add_circle_outline</v-icon>
                </v-btn>
              </template>
              <span>Exportar Inexigibilidade</span>
            </v-tooltip>

            <div class="justify-end">
              <v-menu offset-y left v-if="demanda.uriRelatorioFornecimentoPedido">
                <v-btn slot="activator" icon>
                  <v-icon color="grey darken-3">more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="visualizarDemanda(demanda)">
                    <v-list-tile-content>
                      <v-list-tile-title>Visualizar</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <v-list-tile @click="baixarRelatorioDemanda(demanda)">
                    <v-list-tile-content>
                      <v-list-tile-title>Baixar</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <v-list-tile v-if="condicaoMostrarBotaoExportar(demanda)" @click="exportarParaContratos(demanda)">
                    <v-list-tile-content>
                      <v-list-tile-title>Exportar para Contratos</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>
          </v-layout>
        </template>
        <v-card>
          <v-card class="white demanda-painel">
            <div class="demanda-top-bar">
              <div class="demanda-data-cadastro" data-testid="demanda-data-cadastro" v-if="demanda && demanda.dataCadastroFormatada">
                <span class="grey--text text--darken-1">Data Criação: {{ demanda.dataCadastroFormatada }}</span>
              </div>
              <div class="demanda-acoes">
                <credenciamento-cancelar-demanda v-if="podeEditar(demanda.situacao)" :demanda-id="demanda.id" @atualizar="buscarDemandas" v-az-auth="'Credenciamento.Editar'"/>
              </div>
            </div>
            <v-data-table
                :headers="itemHeaders"
                :items="demanda.itens"
                :options="paginacoesItensPorDemanda[demanda.id]"
                :server-items-length="totalItensPorDemanda[demanda.id]"
                hide-actions
            >
              <template v-slot:items="props">
                <tr :key="props.item.id">
                  <td>{{ props.item.tipoItem }}</td>
                  <td>{{ props.item.sequencia }}</td>
                  <td>
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <v-tooltip top class="tooltip-arredondado">
                        <template #activator="{ on, attrs }">
                          <chip-round
                            v-bind="attrs"
                            v-on="on"
                            :label="getTipoMaterialServico(props.item.tipo, 'sigla')"
                            :tamanho-fonte="'11px'"
                          />
                        </template>
                        <span style="white-space: nowrap;">
                          {{ getTipoMaterialServico(props.item.tipo, 'text') }}
                        </span>
                      </v-tooltip>
                      <span class="mr-1">{{ props.item.descricao }} </span>
                    </div>
                  </td>
                  <td>{{ props.item.unidadeAquisicao }}</td>
                  <td class="text-xs-center">
                    <div class="d-flex align-center justify-center">
                      <v-text-field
                          v-if="isEditingDemanda(demanda.id)"
                          v-model="editingItems[props.item.id]"
                          type="number"
                          min="0"
                          dense
                          solo
                          hide-details
                          class="edit-quantity-field"
                          @keyup.enter="confirmarAlteracoes(demanda)"
                          @keyup.esc="cancelarEdicaoDemanda(demanda.id)"
                      ></v-text-field>

                      <span v-else>{{ props.item.quantidade }}</span>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <paginacao-tabela
                class="mb-2"
                :page="(paginacoesItensPorDemanda[demanda.id] && paginacoesItensPorDemanda[demanda.id].page) || 1"
                :itemsPerPage="(paginacoesItensPorDemanda[demanda.id] && paginacoesItensPorDemanda[demanda.id].rowsPerPage) || 10"
                :totalPaginas="totalPaginasPorDemanda[demanda.id] || 0"
                :totalItens="totalItensPorDemanda[demanda.id] || 0"
                @update-page="novaPagina => atualizarPaginaItens(demanda.id, novaPagina)"
            >
              <template #pagination-actions> <slot name="pagination-actions"></slot> </template>
            </paginacao-tabela>
          </v-card>
        </v-card>
      </v-expansion-panel-content>
      </template>
    </v-expansion-panel>
    <paginacao-tabela
        class="mb-5"
        show-items-per-page
        :page="paginacaoInterna.page"
        :itemsPerPage="paginacaoInterna.rowsPerPage"
        :totalPaginas="totalPaginas"
        :totalItens="totalItens"
        @update-page="tratarEventoAtualizarPagina"
        @update-items-per-page="tratarEventoAtualizarItensPorPagina"
    >
      <template #pagination-actions> <slot name="pagination-actions"></slot> </template>
    </paginacao-tabela>
    <v-snackbar
        :value="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :top="snackbar.top"
        :right="snackbar.right"
        :multi-line="snackbar.multiLine"
    >
      {{ snackbar.message }}
      <v-btn text dark @click="snackbar.visible = false">
        <v-icon small>close</v-icon>
      </v-btn>
    </v-snackbar>

    <modal-selecionar-documentos-demanda
      v-if="exibirModalSelecionarDocumentos && demandaSelecionada"
      :exibirModal="exibirModalSelecionarDocumentos"
      :credenciamentoId="credenciamentoId"
      :demandaId="demandaSelecionada && demandaSelecionada.id"
      @fechar-modal="fecharModalSelecionarDocumentos"
      @enviar="onEnviarDocumentos"
    />
  </v-container>
</template>

<script>
import CredenciamentoModalNovaDemanda
  from "@/views/credenciamento/detalhe-credenciamento/orgao/execucao/Modal/CredenciamentoModalNovaDemanda.vue";
import ModalSelecionarDocumentosDemanda
  from "@/views/credenciamento/detalhe-credenciamento/fornecedor/modal/ModalSelecionarDocumentosDemanda.vue";
import actionTypes from "@/commons/constants/action-types";
import CredenciamentoCancelarDemanda
  from "@/views/credenciamento/detalhe-credenciamento/orgao/execucao/Modal/CredenciamentoCancelarDemanda.vue";
import CredenciamentoModalMotivoCancelamento
  from "@/views/credenciamento/detalhe-credenciamento/orgao/execucao/Modal/CredenciamentoModalMotivoCancelamento.vue";
import PaginacaoTabela from "@/commons/components/PaginacaoTabela.vue";
import ChipRound from "@/views/credenciamento/detalhe-credenciamento/commons/ChipRound.vue";

export default {
  components: {
    PaginacaoTabela,
    ChipRound,
    CredenciamentoModalMotivoCancelamento,
    CredenciamentoCancelarDemanda,
    CredenciamentoModalNovaDemanda,
    ModalSelecionarDocumentosDemanda
  },
  data: () => ({
    itemHeaders: [
      { text: 'Tipo', value: 'tipoItem', sortable: false, width: '7%' },
      { text: 'Seq.', value: 'sequencia', sortable: false, width: '5%' },
      { text: 'Código/Descrição', value: 'descricao', sortable: false, width: '58%' },
      { text: 'Un. Aquisição', value: 'unidadeAquisicao', sortable: false, width: '10%' },
      { text: 'Quantidade', value: 'quantidade', sortable: false, align: 'center', width: '20%' },
    ],
    suspendWatcher: false,
    procurandoDemandaId: null,
    paginaOriginal: 1,
    snackbar: {
      visible: false,
      message: '',
      color: 'error',
      timeout: 4000,
      top: true,
      right: true,
      multiLine: false
    },
    demandas: null,
    painelAberto: null,
    credenciamentoId: null,
    editingDemandaId: null,
    editingItems: {},
    originalQuantities: {},
    totalItens: 0,
    totalPaginas: 0,
    paginacaoInterna: {
      groupBy: [],
      groupDesc: [],
      rowsPerPage: 10,
      multiSort: false,
      mustSort: false,
      page: 1,
      sortBy: 'id',
      sortByDefault: ['id'],
      descending: false,
      sortDescDefault: [true]
    },
    paginacoesItensPorDemanda: {},
    totalItensPorDemanda: {},
    totalPaginasPorDemanda: {},
    demandasComPreparacaoAberta: {},
    janelasProcessoAquisicao: {},
    monitoresJanela: {},
    exibirModalSelecionarDocumentos: false,
    demandaSelecionada: null
  }),
  beforeDestroy() {
    Object.values(this.monitoresJanela).forEach(intervalo => {
      clearInterval(intervalo)
    })
  },
  watch: {
    paginacaoInterna: {
      async handler() {
        if (this.suspendWatcher) return;
        await this.buscarDemandas();
      },
      deep: true,
    },
    painelAberto(novoIndice) {
      if (novoIndice != null && this.demandas && this.demandas.itens[novoIndice]) {
        const demanda = this.demandas.itens[novoIndice];
        this.abrirPainel(demanda);
      }
    }
  },
  async mounted(){
    this.credenciamentoId = this.$route.params.id;
    const idContratacao = this.$route && this.$route.query && this.$route.query.contratacao
      ? Number(this.$route.query.contratacao)
      : null;

    if (idContratacao) {
      await this.abrirDemandaPorId(idContratacao);
    } else {
      await this.buscarDemandas();
    }
  },

  methods: {
    getTipoMaterialServico(sigla, chave) {
      const mod = require('@/commons/constants/tipo-item-material-servico').default || {};
      const lista = Object.values(mod);
      const norm = v => (v || '').toString().trim().toUpperCase();
      const t = norm(sigla);
      let item = lista.find(el => norm(el.sigla) === t || norm(el.value) === t || norm(el.text) === t);
      if (!item) {
        if (t.startsWith('M')) item = lista.find(el => norm(el.value) === 'MATERIAL');
        if (!item && (t.startsWith('S') || t.startsWith('SERV'))) item = lista.find(el => norm(el.value) === 'SERVICO');
      }
      return item ? item[chave] : null;
    },
    async buscarDemandas(options = { resetPainel: true }){
      const dados = {
        credenciamentoId: this.credenciamentoId,
        paginacao: this.paginacaoInterna,
      }
      const response = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_DEMANDAS_CREDENCIAMENTO, dados)

      if (response) {
        this.demandas = response
        this.totalItens = response.totalElements;
        this.totalPaginas = response.totalPages;
        this.incluirItens()
      }
      if (options && options.resetPainel) {
        this.painelAberto = null;
      }
      return response;
    },
    incluirItens() {
      if (this.demandas && this.demandas.itens) {
        this.demandas.itens.forEach(demanda => {
          if (!demanda.hasOwnProperty('itens')) {
            this.$set(demanda, 'itens', []);
          }
        });
      }
    },
    async abrirDemandaPorId(idDemanda) {
      this.procurandoDemandaId = Number(idDemanda);
      this.paginaOriginal = this.paginacaoInterna && this.paginacaoInterna.page ? this.paginacaoInterna.page : 1;

      try {
        this.suspendWatcher = true;

        this.paginacaoInterna.page = 1;
        await this.buscarDemandas({ resetPainel: true });

        let page = 1;
        let totalPages = this.totalPaginas || 1;
        let encontrada = false;

        while (page <= totalPages && !encontrada) {
          const idx = this.demandas && this.demandas.itens
            ? this.demandas.itens.findIndex(d => Number(d.id) === Number(idDemanda))
            : -1;

          if (idx >= 0) {
            this.painelAberto = idx;
            const demanda = this.demandas.itens[idx];
            await this.abrirPainel(demanda);
            encontrada = true;
            break;
          }

          page += 1;
          if (page <= totalPages) {
            this.paginacaoInterna.page = page;
            const resp = await this.buscarDemandas({ resetPainel: true });
            totalPages = this.totalPaginas || (resp && resp.totalPages) || totalPages;
          }
        }

        if (!encontrada) {
          this.paginacaoInterna.page = 1;
          await this.buscarDemandas({ resetPainel: true });
        }
      } finally {
        this.suspendWatcher = false;
        this.procurandoDemandaId = null;
      }
    },
    deveMostrarBotaoIrParaPreparacao(demanda) {
      const props = this.$store.state.parametros && this.$store.state.parametros.propriedadesLicitacao
      return props && props.exportarDemandaInexigibilidade === true && demanda.situacao === 'Aprovada' && demanda.exportadoContratos === false && !demanda.numeroProcesso && !this.demandasComPreparacaoAberta[demanda.id]
    },
    visualizarDemanda(demanda) {
      this.$router.push({
        name: 'AnaliseDemandaCredenciamento',
        params: {
          id: this.credenciamentoId,
          demandaId: demanda.id
        },
        query: {
          edicao: false,
          voltar: 'edicao'
        }
      });
    },
    baixarRelatorioDemanda(demanda) {
      const documento = this.formatarDocumento(demanda);
      this.tratarEventoDownload(documento);
    },
    formatarDocumento(demanda) {
      const d = demanda;
      return {
        uri: d.uriRelatorioFornecimentoPedido,
        url: '/hal/public/arquivos?uri=' + d.uriRelatorioFornecimentoPedido + '&thumbnail=false',
      }
    },
    tratarEventoDownload(documento) {
      this.$store.dispatch(actionTypes.CREDENCIAMENTO.BAIXAR_DOCUMENTO, documento)
    },
    isEditingDemanda(demandaId) {
      return this.editingDemandaId === demandaId;
    },
    hasAnyQuantityChanged(demanda) {
      if (!demanda.itens || !this.isEditingDemanda(demanda.id)) {
        return false;
      }

      return demanda.itens.some(item => {
        const currentValue = this.editingItems[item.id];
        const originalValue = this.originalQuantities[item.id];
        return currentValue != null &&
            currentValue !== '' &&
            Number(currentValue) !== Number(originalValue);
      });
    },
    async toggleEdicaoDemanda(demanda) {
      const demandaIndex = this.demandas.itens.findIndex(d => d.id === demanda.id);

      if (this.isEditingDemanda(demanda.id)) {
        this.cancelarEdicaoDemanda(demanda.id);
      } else {
        if (this.painelAberto !== demandaIndex) {
          this.painelAberto = demandaIndex;
          await this.abrirPainel(demanda);
        }

        this.iniciarEdicaoDemanda(demanda);
      }
    },

    iniciarEdicaoDemanda(demanda) {
      this.editingDemandaId = demanda.id;

      if (demanda.itens) {
        demanda.itens.forEach(item => {
          this.$set(this.editingItems, item.id, item.quantidade);
          this.$set(this.originalQuantities, item.id, item.quantidade);
        });
      }
    },
    cancelarEdicaoDemanda() {
      this.editingDemandaId = null;

      Object.keys(this.editingItems).forEach(key => {
        this.$delete(this.editingItems, key);
      });
      Object.keys(this.originalQuantities).forEach(key => {
        this.$delete(this.originalQuantities, key);
      });
    },
    tratarEventoAtualizarPagina(page) {
      this.paginacaoInterna.page = page
    },
    tratarEventoAtualizarItensPorPagina(rowsPerPage) {
      this.paginacaoInterna.page = 1
      this.paginacaoInterna.rowsPerPage = rowsPerPage
    },
    async confirmarAlteracoes(demanda) {
      const itensAlteradosParaBackend = [];
      let temErro = false;

      demanda.itens.forEach(item => {
        const novaQuantidade = this.editingItems[item.id];
        const quantidadeOriginal = this.originalQuantities[item.id];

        if (novaQuantidade != null &&
            novaQuantidade !== '' &&
            Number(novaQuantidade) !== Number(quantidadeOriginal)
        ) {
          const parsedQuantity = Number(novaQuantidade);
          if (isNaN(parsedQuantity) || parsedQuantity < 0) {
            this.snackbar.message = `Quantidade do item ${item.sequencia} é inválida ou negativa.`;
            this.snackbar.color = 'error';
            this.snackbar.visible = true;
            temErro = true;
            return;
          }

          itensAlteradosParaBackend.push({
            id: item.id,
            quantidade: parsedQuantity
          });
        }
      });

      if (temErro) {
        return;
      }

      if (itensAlteradosParaBackend.length === 0) {
        this.cancelarEdicaoDemanda(demanda.id);
        return;
      }

      try {
        this.habilitarLoadingGlobal()

        const payloadParaBackend = {
          itens: itensAlteradosParaBackend,
          situacao: "AGUARDANDO_APROVACAO"
        };

        const dadosParaAction = {
          demandaId: demanda.id,
          dados: payloadParaBackend
        };

        const resposta = await this.$store.dispatch(
            actionTypes.CREDENCIAMENTO.DEMANDA.EDITAR_CANCELAR_DEMANDA,
            dadosParaAction
        );

        if (resposta) {
          itensAlteradosParaBackend.forEach(altItem => {
            const itemLocal = demanda.itens.find(i => i.id === altItem.id);
            if (itemLocal) {
              itemLocal.quantidade = altItem.quantidade;
            }
          });

          this.cancelarEdicaoDemanda(demanda.id);
        }
        this.mostrarNotificacaoSucessoDefault()
        this.desabilitarLoadingGlobal()
      } catch (e) {
        this.desabilitarLoadingGlobal()
      }
    },
    atualizarPaginaItens(demandaId, novaPagina) {
      this.paginacoesItensPorDemanda[demandaId].page = novaPagina;
      const demanda = this.demandas.itens.find(d => d.id === demandaId);
      this.abrirPainel(demanda);
    },
    async abrirPainel(demanda) {
      const demandaId = demanda.id;

      if (!this.paginacoesItensPorDemanda[demandaId]) {
        this.$set(this.paginacoesItensPorDemanda, demandaId, {
          page: 1,
          rowsPerPage: 10,
          sortBy: 'id',
          descending: false,
        });
      }

      try {
        const paginacao = this.paginacoesItensPorDemanda[demandaId];

        const dados = {
          demandaId: demandaId,
          paginacao: paginacao
        };

        const resposta = await this.$store.dispatch(
            actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_ITENS_POR_DEMANDA,
            dados
        );

        this.$set(demanda, 'itens', resposta && resposta.itens ? resposta.itens : []);
        this.$set(this.totalItensPorDemanda, demandaId, resposta && resposta.totalElements ? resposta.totalElements : 0);
        this.$set(this.totalPaginasPorDemanda, demandaId, resposta && resposta.totalPages ? resposta.totalPages : 0);
      } catch (e) {
        this.snackbar.message = 'Erro ao carregar itens da contratação';
        this.snackbar.color = 'error';
        this.snackbar.visible = true;
      }
    },
    podeEditar(demanda){
      return !(demanda === "Aprovada" || demanda === "Cancelada");
    },
    condicaoMostrarBotaoExportar(demanda) {
      const props = this.$store.state.parametros && this.$store.state.parametros.propriedadesLicitacao
      const permitir = props && props.exportarDemandaContrato === true
      return permitir && demanda && demanda.exportadoContratos === false && demanda.situacao === 'Aprovada' && !demanda.numeroProcesso
    },
    async exportarParaContratos(demanda) {
      try {
        await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DEMANDA.EXPORTAR_DEMANDA_PARA_CONTRATOS, { demandaId: demanda.id })
        this.mostrarNotificacaoSucesso(`Contratação Nº ${demanda.numero} exportada para o módulo de contratos  com sucesso!`)
        await this.buscarDemandas()
      } catch (e) {
        if (this.mostrarNotificacaoErroDefault) {
          this.mostrarNotificacaoErroDefault()
        }
        // eslint-disable-next-line
        console.error(e)
      }
    },
    abrirModalSelecionarDocumentos(demanda) {
      this.demandaSelecionada = demanda
      this.exibirModalSelecionarDocumentos = true
    },
    fecharModalSelecionarDocumentos() {
      this.exibirModalSelecionarDocumentos = false
      this.demandaSelecionada = null
    },
    onEnviarDocumentos() {
      const demanda = this.demandaSelecionada
      this.fecharModalSelecionarDocumentos()
      this.irParaPreparacao(demanda)
    },
    irParaPreparacao(demanda) {
        const base = window.location.origin
        const credId = encodeURIComponent(this.credenciamentoId)
        const demId = encodeURIComponent(demanda && demanda.id)
        const url = `${base}/compras-preparacao/#/processos/criacao?credenciamentoId=${credId}&demandaId=${demId}`

      const janela = window.open(url, '_blank')

      this.$set(this.demandasComPreparacaoAberta, demanda.id, true)
      this.$set(this.janelasProcessoAquisicao, demanda.id, janela)

      if (this.monitoresJanela[demanda.id]) {
        clearInterval(this.monitoresJanela[demanda.id])
      }

      this.monitoresJanela[demanda.id] = setInterval(() => {
        const janelaAtual = this.janelasProcessoAquisicao[demanda.id]

        if (janelaAtual && janelaAtual.closed) {
          this.$delete(this.demandasComPreparacaoAberta, demanda.id)
          this.$delete(this.janelasProcessoAquisicao, demanda.id)

          clearInterval(this.monitoresJanela[demanda.id])
          this.$delete(this.monitoresJanela, demanda.id)

          this.buscarDemandas()
        }
      }, 1000)
    },
    abrirProcessoAquisicao(demanda) {
      if (!demanda || !demanda.idExternoProcessoAquisicao) return;

      const base = window.location.origin;
      const processoId = encodeURIComponent(demanda.idExternoProcessoAquisicao);

      const url = `${base}/compras-preparacao/#/processos/${processoId}/edicao/informacoes`;

      window.open(url, '_blank');
    }
  }
}
</script>

<style scoped lang="stylus">
.demanda-painel {
  margin-bottom: 8px;
  border-radius: 4px;
  background-color: white !important;
  box-shadow: none !important;
  position: relative;
}

.demanda-top-bar {
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  left: 12px;
  right: 12px;
}

.demanda-data-cadastro {
  display: flex;
  align-items: center;
}

.demanda-acoes {
  display: flex;
  align-items: center;
}

.header-info span {
  font-size: 0.9em;
  color: rgba(0, 0, 0, 0.6);
}

.custom-table-header-text-color thead th {
  font-weight: 500;
  background-color: transparent !important;
}

.demand-items-table tbody tr {
  border-bottom: none !important;
}

.demand-items-table tbody td {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.v-btn--icon.v-btn--small .v-icon {
  font-size: 18px !important;
}

.edit-quantity-field {
  max-width: 80px !important;
  min-width: 60px !important;
}

.edit-quantity-field >>> .v-input__control {
  min-height: 32px !important;
}

.edit-quantity-field >>> .v-text-field__details {
  display: none !important;
}

.edit-quantity-field {
  background-color: #ffffff !important;
  border: 1px solid #0000a0 !important;
  border-radius: 6px;
  box-shadow: 0 0 4px #0067a5;
}

.edit-btn {
  opacity: 0.7;
  transition: opacity 0.2s;
}

.edit-btn:hover {
  opacity: 1;
}

.v-btn {
  transition: all 0.2s ease;
}

.confirmar {
  font-weight: 700;
}

.demanda-expansion >>> .v-expansion-panel__container {
  background-color: #ffffff !important;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin-bottom: 10px;
  overflow: hidden;
  box-shadow: none !important;
}

.demanda-expansion >>> .v-expansion-panel__header {
  background-color: #ffffff !important;
}

.demanda-expansion >>> .v-expansion-panel__container.v-expansion-panel__container--active .v-expansion-panel__header,
.demanda-expansion >>> .v-expansion-panel__header--active {
  background-color: #f5f5f5 !important;
}

.processo-link {
  color: #1976d2;
  cursor: pointer;
  position: relative;
  transition: color 0.2s ease, transform 0.15s ease;
}

.processo-link:hover {
  color: #0d47a1;
  transform: translateY(-1px);
}

.processo-link:focus {
  outline: none;
}
</style>